import React from 'react';
import ThroneSeatElements from '../Seatmap/utils/throne-seat-elements';
import css from '../Seatmap/seat-map.module.css';
import TitleItem from './TitleItem';

function SeatTitle({ seat, color }) {
    const Icon = ThroneSeatElements[seat.state] || ThroneSeatElements.available;

    return (
        <>
            <style>{`svg.selected-seat-icon-${seat?.uuid} path {
                fill: ${color} !important;
            }`}</style>

            <div className={css['selected-seats-title']}>
                <span className={css['selected-seat-icon-container']}>
                    <Icon className={`${css['selected-seat-icon']} selected-seat-icon-${seat?.uuid}`} />
                </span>
                <TitleItem title={'ticket.attendees.import.errors.details.seat_seat'} value={seat.seat} />
                <span className={css['separator']}>•</span>
                <TitleItem title={'ticket.attendees.import.errors.details.seat_row'} value={seat.row} />
                <span className={css['separator']}>•</span>
                <TitleItem title={'ticket.attendees.import.errors.details.seat_access'} value={seat.access} />
            </div>
        </>
    );
}

export default SeatTitle;
